<template>
  <base-section id="descubre">
    <base-section-heading title="Descubre Paint Clean Box">
      La solución perfecta para limpiar tus rodillos de pintura al agua
    </base-section-heading>

    <v-container>
      <v-row>
        <v-col
          v-for="(video, i) in videos"
          :key="i"
          cols="12"
          md="6"
        >
          <v-responsive
            max-width="600"
            width="100%"
          >
            <iframe
              :width="dimensionVideo.w"
              :height="dimensionVideo.h"
              :src="video"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </v-responsive>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          md="4"
        >
          <base-avatar-card
            v-bind="feature"
            align="left"
            horizontal
          >
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis illum veniam cum dolores ratione commodi beatae quas maxime, laboriosam excepturi solut!
          </base-avatar-card>

          <base-img
            v-bind="feature"
          />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionDescubre',

    data: () => ({
      features: [
        {
          title: 'Fácil',
          icon: 'mdi-bike',
          text: 'Sin manchar nada.',
          src: require('@/assets/facil.jpg'),
        },
        {
          title: 'Rápido',
          icon: 'mdi-alarm-check',
          text: 'En menos de 1 minuto.',
          src: require('@/assets/rapido.jpg'),
        },
        {
          color: 'primary',
          dark: true,
          title: 'Eficaz',
          icon: 'mdi-beaker-check-outline',
          text: 'Ahorra un 80% de agua.',
          src: require('@/assets/eficaz.jpg'),
        },
      ],
      videos: [
        'https://www.youtube.com/embed/N9DJvEelzRw',
        'https://www.youtube.com/embed/obwo8dG1FvA',
      ],
    }),

    computed: {
      media () {
        return this.$vuetify.breakpoint
      },

      dimensionVideo () {
        const w = 560
        const h = 315
        const result = {
          w: this.media.width < w ? this.media.width - 20 : w,
          h: this.media.width < w ? h * (this.media.width - 20) / w : h,
        }
        return result
      },
    },
  }
</script>
